// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".with-copy[data-v-bae1bcd0]{border:solid 1px var(--border);padding:10px;position:relative;background-color:var(--input-bg);border-radius:var(--border-radius);border:solid var(--border-width) var(--input-border)}.with-copy>button[data-v-bae1bcd0]{position:absolute;top:-1px;right:-1px;border-radius:0 0 0 var(--border-radius)}.monospace[data-v-bae1bcd0]{white-space:pre-wrap;word-wrap:break-all}", ""]);
// Exports
module.exports = exports;
